import { APIDataProps } from "../stores/apiData";

let countryKeys = {};

let countryData = {};

const processCountryDataItem = item => {
  countryData[item.properties.sr_su_a3] = {
    coordinates: item.geometry.coordinates,
    name: item.properties.sr_subunit,
    id: item.properties.sr_su_a3,
    iso: item.properties.sr_su_a3,
    documents: [],
    recommendations: [],
    2018: {
      imports: [],
      population: null,
      gdp: null
    },
    2023: {
      imports: [],
      population: null,
      gdp: null
    }
  };
  countryKeys[item.properties.sru_su_a3] = item.properties.sr_subunit;
};

export default async function fetchCountries(): APIDataProps {
  const response = await fetch("https://d2ad6b4ur7yvpq.cloudfront.net/naturalearth-3.3.0/ne_50m_admin_0_scale_rank.geojson");
  const data = await response.json();

  data.features.forEach(feature => {
    processCountryDataItem(feature);
  });

  let tempObjectForFilteredCountry = {};

  Object.keys(countryData).forEach(key => {
    if (countryData[key].region) {
      tempObjectForFilteredCountry[key] = countryData[key];
    }
  });

  countryData = tempObjectForFilteredCountry;

  return new Promise((resolve, reject) => {
    resolve({
      globals: {
        worldwide_prevalence_statement:
          "A statement on global prevalence as an average/aggregate figure, how this score is calculated etc...",
        tooltips: {},
        2018: {
          worldwide_prevalence_value: 53.2,
          documents: []
        },
        2023: {
          worldwide_prevalence_value: 23.2,
          documents: []
        }
      },
      regions: null,
      countries: countryData
    });
  });
}
